__turbopack_context__.v({
  "actions": "notification-item-module__ITZjOq__actions",
  "body": "notification-item-module__ITZjOq__body",
  "comfortable": "notification-item-module__ITZjOq__comfortable",
  "compact": "notification-item-module__ITZjOq__compact",
  "dismiss": "notification-item-module__ITZjOq__dismiss",
  "dot": "notification-item-module__ITZjOq__dot",
  "isRead": "notification-item-module__ITZjOq__isRead",
  "isUnread": "notification-item-module__ITZjOq__isUnread",
  "item": "notification-item-module__ITZjOq__item",
  "itemComfortable": "notification-item-module__ITZjOq__itemComfortable",
  "itemCompact": "notification-item-module__ITZjOq__itemCompact",
  "itemLeaving": "notification-item-module__ITZjOq__itemLeaving",
  "job_complete": "notification-item-module__ITZjOq__job_complete",
  "markReadHint": "notification-item-module__ITZjOq__markReadHint",
  "meta": "notification-item-module__ITZjOq__meta",
  "qc_review": "notification-item-module__ITZjOq__qc_review",
  "row": "notification-item-module__ITZjOq__row",
  "system_alert": "notification-item-module__ITZjOq__system_alert",
  "text": "notification-item-module__ITZjOq__text",
  "tile": "notification-item-module__ITZjOq__tile",
  "time": "notification-item-module__ITZjOq__time",
  "title": "notification-item-module__ITZjOq__title",
});
